<template>
  <ReactPage>
    <registration-acs-status-report-page></registration-acs-status-report-page>
  </ReactPage>
</template>

<script>
import ReactPage from '../components/ReactPage.vue';

export default {
  name: "RegistrationACSStatusReport",
  components: {
    ReactPage
  }
}
</script>